import { createIcon } from '@chakra-ui/icons';

export const AngleRight = createIcon({
  displayName: 'AngleRight',
  viewBox: '0 0 4 6',
  path: [
    <svg width="4" height="6" viewBox="0 0 4 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 0.5 L3 3L0.5 5.5"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
